/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ServiceRequestCode = {
    NotSpecified: 'NotSpecified',
    Disconnect: 'Disconnect',
    CloseDown: 'CloseDown',
    Connect: 'Connect',
    ReadingRequest: 'ReadingRequest',
    MeterCheck: 'MeterCheck',
    FlexChange: 'FlexChange',
    NonProfiledChange: 'NonProfiledChange',
    DisconnectDueToEndOfSupply: 'DisconnectDueToEndOfSupply',
    TheMunicipalityIsInvolvedInTheDisconnection: 'TheMunicipalityIsInvolvedInTheDisconnection',
    ThePoliceIsInvolvedInTheDisconnection: 'ThePoliceIsInvolvedInTheDisconnection',
    TheBailiffsCourtIsInvolvedInTheDisconnection: 'TheBailiffsCourtIsInvolvedInTheDisconnection',
    OrdinaryDisconnectionAgreedWithTheCustomer: 'OrdinaryDisconnectionAgreedWithTheCustomer',
    OtherReason: 'OtherReason',
    EtablishElectricHeating: 'EtablishElectricHeating',
    RemoveElectricHeating: 'RemoveElectricHeating',
} as const;
export type ServiceRequestCode = typeof ServiceRequestCode[keyof typeof ServiceRequestCode];

